module.exports = Object.freeze({
  PRERENDERED_DATA_DIRECTORY: "Prerendered",
  INFO_JSON: "Prerendered/info.json",
  VISUAL_IMAGE: "Prerendered/visual.jpg",
  PREVIEW_IMAGE: "Prerendered/preview.jpg",
  PHOTONOTE_DIRECTORY: "Prerendered/photonotes",
});
